import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { formatCount, formatExactCount } from '../../lib/formatCount';

// Compact number (1.25k / 2.50M) with the exact value on hover/focus. Brings its own
// TooltipProvider -- the app has no global one, and a Tooltip without a Provider
// throws (see the GearRatioCalculator bug noted in project memory).
const CompactCount = ({ value, className = '', ...rest }) => {
  const compact = formatCount(value);
  const exact = formatExactCount(value);
  if (compact === exact) {
    return <span className={className} {...rest}>{compact}</span>;
  }
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className={`cursor-help ${className}`} aria-label={exact} {...rest}>
            {compact}
          </span>
        </TooltipTrigger>
        <TooltipContent>{exact}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CompactCount;
